/*
  Store-specific header behaviour, kept out of the theme's own scripts so it
  survives theme updates and works with the minified theme scripts.
  - Closes open desktop menus when the sticky header appears or disappears.
  - Closes open desktop menus on scroll on touch devices (iPad Safari).
  - Desktop: search sits in the logo row; mobile: search sits in the menu row.
*/
(function () {
  if (window.__customHeaderLoaded) return;
  window.__customHeaderLoaded = true;

  var DESKTOP_MIN = 799;

  function closeAllMenus() {
    var manager = window.navigationDesktopManager;
    if (manager && Array.isArray(manager.desktopNavs)) {
      manager.desktopNavs.forEach(function (nav) {
        if (nav && nav.headerNavMenu && typeof nav.headerNavMenu.closeAllMenus === 'function') {
          nav.headerNavMenu.closeAllMenus();
        }
      });
    }
    document
      .querySelectorAll('.main-nav__wrapper details[open], .sticky_nav details[open]')
      .forEach(function (details) {
        details.removeAttribute('open');
        details.setAttribute('aria-expanded', 'false');
      });
  }

  function applySearchLayout() {
    var mainHeader = document.querySelector('.header-group .header');
    if (!mainHeader) return;

    var logoRowSearch = mainHeader.querySelector('.logo-search-row .search-container');
    var inDesktop = window.innerWidth >= DESKTOP_MIN;

    // The sticky header never shows the logo-row search.
    document.querySelectorAll('.sticky_nav .logo-search-row .search-container').forEach(function (el) {
      el.style.display = 'none';
    });

    if (logoRowSearch) logoRowSearch.style.display = inDesktop ? '' : 'none';
    mainHeader.querySelectorAll('.search-container').forEach(function (el) {
      if (!el.closest('.logo-search-row')) el.style.display = inDesktop ? 'none' : '';
    });
  }

  // The theme adds/removes "sticky_nav--stick" on its sticky header clone.
  function watchSticky(sticky) {
    if (sticky.__customHeaderWatched) return;
    sticky.__customHeaderWatched = true;
    var wasStuck = sticky.classList.contains('sticky_nav--stick');
    new MutationObserver(function () {
      var isStuck = sticky.classList.contains('sticky_nav--stick');
      if (isStuck !== wasStuck) {
        wasStuck = isStuck;
        closeAllMenus();
      }
    }).observe(sticky, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    document.querySelectorAll('.sticky_nav').forEach(watchSticky);
    applySearchLayout();
  }

  // The sticky clone is created by the theme after load (and again when the
  // header is re-rendered in the theme editor), so re-run when the page changes.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      init();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  window.addEventListener('resize', applySearchLayout, { passive: true });
  window.addEventListener('orientationchange', applySearchLayout, { passive: true });

  var isTouch =
    (window.matchMedia &&
      (window.matchMedia('(pointer: coarse)').matches || window.matchMedia('(hover: none)').matches)) ||
    'ontouchstart' in window;

  if (isTouch) {
    var lastCloseAt = 0;
    window.addEventListener(
      'scroll',
      function () {
        var now = Date.now();
        if (now - lastCloseAt > 150) {
          closeAllMenus();
          lastCloseAt = now;
        }
      },
      { passive: true }
    );
  }

  // Essential Loyalty puts its cart box ("+139 points for this order") before
  // the first .checkout_button it finds at load, and keeps it there. The theme
  // has three copies of the mini cart (sticky, mobile, desktop), so keep a
  // single .minicart-checkout wrapper (box + checkout button) and move it into
  // whichever copy is on screen.
  function syncRewardsAnchor() {
    var slots = Array.prototype.slice.call(document.querySelectorAll('.cart-container .minicart-checkout-slot'));
    if (!slots.length) return;
    var wrappers = Array.prototype.slice.call(document.querySelectorAll('.cart-container .minicart-checkout'));
    if (!wrappers.length) return;
    // The app inserts its box inside the wrapper (before .checkout_button), so
    // the wrapper that holds the box is the one to keep; it moves as a unit.
    var keeper = wrappers.filter(function (w) { return w.querySelector('.honeypop-cp'); })[0]
      || wrappers.filter(function (w) { return w.classList.contains('is-keeper'); })[0] || wrappers[0];
    keeper.classList.add('is-keeper');
    wrappers.forEach(function (w) { if (w !== keeper) w.parentNode.removeChild(w); });

    var target = null;
    slots.forEach(function (slot) {
      var rect = slot.closest('.cart-container').getBoundingClientRect();
      var onScreen = rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
      if (onScreen && !target) target = slot;
    });
    if (target && keeper.parentElement !== target) target.appendChild(keeper);
  }
  var anchorPending = false;
  function scheduleAnchorSync() {
    if (anchorPending) return;
    anchorPending = true;
    requestAnimationFrame(function () { anchorPending = false; syncRewardsAnchor(); });
  }
  if (document.querySelector('.minicart-checkout-slot')) {
    syncRewardsAnchor();
    window.addEventListener('scroll', scheduleAnchorSync, { passive: true });
    window.addEventListener('resize', scheduleAnchorSync, { passive: true });
    window.addEventListener('load', scheduleAnchorSync);
    new MutationObserver(scheduleAnchorSync).observe(document.body, { childList: true, subtree: true });
  }
})();

/*
  Product page: the Mailchimp "Notify me when available" button takes the
  place of the greyed-out Sold out button (it is moved into the same row;
  the CSS in custom-mega.css hides Sold out while the Notify button shows).
*/
(function () {
  function moveNotifyButton() {
    var block = document.querySelector('.mailchimp-for-shopify-product-block');
    var slot = document.querySelector('.purchase-details__buttons');
    if (block && slot && !slot.contains(block)) slot.appendChild(block);
  }
  moveNotifyButton();
  document.addEventListener('DOMContentLoaded', moveNotifyButton);
  window.addEventListener('load', moveNotifyButton);
  // Mailchimp can inject its block late: keep checking for 10 seconds on product pages, then stop.
  if (document.querySelector('.purchase-details__buttons')) {
    var tries = 0;
    var t = setInterval(function () {
      moveNotifyButton();
      if (++tries > 20) clearInterval(t);
    }, 500);
  }
})();

/* "Save £80.00" tag next to the price: show whole amounts without ".00" ("Save £80"), also after the
   currency switcher rewrites the amount. Amounts with pence (£80.50) are left as they are. */
(function () {
  function tidy(root) {
    (root || document).querySelectorAll('.sg-save .money').forEach(function (m) {
      var t = m.textContent, n = t.replace(/([.,])00(?=\D*$)/, '');
      if (n !== t) m.textContent = n;
    });
  }
  // Watches only the price boxes on product pages (nothing at all on other pages), so it costs nothing elsewhere.
  function start() {
    var boxes = document.querySelectorAll('.product_section [data-price-ui]');
    if (!boxes.length) return;
    tidy();
    var mo = new MutationObserver(function () { tidy(); });
    boxes.forEach(function (b) { mo.observe(b, { childList: true, subtree: true, characterData: true }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Chat and Rewards links (Oct 2026). The apps' floating buttons are hidden (custom-mega.css); any element with
   data-sg-chat or data-sg-rewards (header chat icon, phone menu, footer, product page) opens the same window
   by pressing the app's own hidden button. Links to #chat / #rewards from elsewhere work too.
   If an app has not loaded yet, it waits a few seconds; if it never loads, chat falls back to email. */
(function () {
  function press(find, fallback, max) {
    var tries = 0;
    (function go() {
      var b = find();
      if (b) { b.click(); return; }
      if (++tries < (max || 30)) { setTimeout(go, 200); return; }
      if (fallback) fallback();
    })();
  }
  /* Speed (15 Oct 2026): the Re:amaze app embed is off, so its chat code (about 210 KB) loads only when someone asks
     for the chat. These are the settings the app embed used to print (account, look, FAQ/orders apps). */
  function loadChat() {
    if (document.getElementById('reamaze-widget') || window.sgChatLoading) return;
    window.sgChatLoading = true;
    var _support = window._support = window._support || { ui: {}, user: {} };
    _support.account = 'shishagear';
    _support.ui.contactMode = 'mixed';
    _support.ui.enableKb = 'true';
    _support.ui.styles = { widgetColor: 'rgb(0, 0, 0)', gradient: true };
    _support.ui.shoutboxFacesMode = 'default';
    _support.ui.shoutboxHeaderLogo = true;
    _support.ui.widget = { icon: 'webChat', displayOn: 'all', fontSize: 'default', allowBotProcessing: true, slug: 'shishagear-chat-slash-contact-form-shoutbox', label: { text: 'Hello!', mode: 'none', delay: 3, duration: 30 }, position: 'bottom-right', size: '58', mobilePosition: 'bottom-right', mobileSize: '58' };
    _support.apps = { recentConversations: {}, faq: { enabled: true }, orders: { enabled: true }, shopper: { enabled: true } };
    _support.ui.appOrder = ['faq', 'orders', 'shopper', 'recentConversations'];
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://cdn.reamaze.com/assets/reamaze-loader.js';
    document.head.appendChild(s);
  }
  function chat() {
    loadChat();
    press(function () { return document.getElementById('reamaze-widget'); },
      function () { location.href = 'mailto:cs@shishagear.com'; }, 75);
  }
  function rewards() {
    press(function () { return document.querySelector('#honeypop-app [class*="LabelLauncher"]'); },
      function () { location.href = '/account'; });
  }
  function closeMenu(el) {
    var d = el.closest('details[data-mobile-menu]');
    if (d && d.open) { var t = d.querySelector('[data-mobile-menu-trigger]'); if (t) t.click(); else d.open = false; }
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-sg-chat]'), r = !c && e.target.closest('[data-sg-rewards]');
    if (!c && !r) return;
    e.preventDefault();
    closeMenu(c || r);
    (c ? chat : rewards)();
  });
  if (location.hash === '#chat') chat();
  if (location.hash === '#rewards') rewards();
})();

/* Phone menu Login row: Shopify's account button only covers the word, so a tap anywhere else on the row
   (including the person icon on the right) presses that button too. */
document.addEventListener('click', function (e) {
  var li = e.target.closest && e.target.closest('#header li.sg-mi--account');
  if (!li || e.target.closest('shopify-account')) return;
  var acct = li.querySelector('shopify-account');
  var btn = acct && acct.shadowRoot && acct.shadowRoot.querySelector('a, button');
  if (btn) btn.click(); else location.href = '/account';
});
